export default [
	{ id: 'ONE', question: 'PP-32 Moves air container in a smooth steady motion (avoids jerking)' },
	{ id: 'TWO', question: 'PP-34 Gets assistance when moving a full air container (located on ends of air container)' },
	{ id: 'THREE', question: 'PP-79 When pulling container, after it begins to move, faces forward (keeping arm bent)' },
	{ id: 'FOUR', question:  'PP-28 Squares shoulders to air container before attempting to push, arms are bent at the elbow' },
	{ id: 'FIVE', question: 'C/i-11 Knocks on container to indicate shifter is ready to start or stop movement of air container' },
	{ id: 'SIX', question: 'SB-42 Looks ahead, scans travel path for tripping hazards, low clearances and falling packages' }
]
